import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_HALAL_STOCK } from "../../../config/api";

export const updateStock = createAsyncThunk(
  "stocks/update",
  async ({ id, data, navigate, setSubmitting }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "PUT",
        path: API_GET_HALAL_STOCK + id,
        data: data,
        // contentType: "multipart/form-data",
        serializerConfig: { indexes: null },
      });
      toast.success("Stock updated successfully");
      navigate(`/stocks/${id}`, { replace: true });
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting && setSubmitting(false);
      return rejectWithValue(error.message);
    }
  },
);
